export const getLanguageFromLocale = (locale: string): string => {
  return locale.split('_')[0] ?? '';
};
